export const mutationTypes = {
  translateIdsStart: '[integrations] translate ids start',
  translateIdsSuccess: '[integrations] translate ids success',
  translateIdsFailure: '[integrations] translate ids failure',

  getReportParamsStart: '[integrations] get report params start',
  getReportParamsSuccess: '[integrations] get report params success',
  getReportParamsFailure: '[integrations] get report params failure',
};

const mutations = {
  [mutationTypes.translateIdsStart]() {},
  [mutationTypes.translateIdsSuccess]() {},
  [mutationTypes.translateIdsFailure]() {},

  [mutationTypes.getReportParamsStart](state) {
    state.isLoading = true;
    state.reportParams = {};
  },
  [mutationTypes.getReportParamsSuccess](state, payload) {
    state.isLoading = false;
    state.reportParams = payload;
  },
  [mutationTypes.getReportParamsFailure](state) {
    state.isLoading = false;
  },
};

export default mutations;
